<app-details-loader [Height]="'50vh'" *ngIf="loadFlag"></app-details-loader>

<ng-container *ngIf="!loadFlag">
  <payarc-page-header title="PayPal Transaction Details">
    <button type="button" payarcButton="secondary" [routerLink]="backToList()">Back</button>
    <button *ngIf="canRefund && (transactionDetails.status === 'COMPLETED' || transactionDetails.status === 'PARTIALLY_REFUNDED')"
            type="button" payarcButton="secondary" (click)="doRefund()">Refund</button>
    <button type="button" payarcButton="primary" (click)="viewPDF()">Export PDF</button>
  </payarc-page-header>

  <payarc-section-card heading="Payment Details">
    <div class="ppd-2col">
      <payarc-detail-card [flat]="true" [rows]="[
        {label: 'Internal (Payarc) ID', value: transactionDetails.id},
        {label: 'Amount', value: (transactionDetails.amount | currency:(transactionDetails.currency || 'USD'):'symbol':'1.2-2') + ' ' + (transactionDetails.currency || 'USD')},
        {label: 'PayPal ID', value: transactionDetails.paypal_id}
      ]"></payarc-detail-card>
      <payarc-detail-card [flat]="true" [rows]="[
        {label: 'Customer Name', value: transactionDetails.customer_name || '--'},
        {label: 'Customer Email', value: transactionDetails.customer_email || '--'},
        {label: 'Type', value: transactionDetails.type | uppercase}
      ]"></payarc-detail-card>
    </div>
    <div class="ppd-2col">
      <payarc-detail-card [flat]="true" [rows]="[
        {label: 'Status', value: transactionDetails.status},
        {label: 'Transaction Date', value: transactionDetails.created_at | date: 'MM/dd/yyyy hh:mm'}
      ]"></payarc-detail-card>
      <div class="ppd-source" *ngIf="transactionDetails.payment_source">
        <span class="ppd-source__label">Payment Source</span>
        <img [src]="'/assets/images/' + transactionDetails.payment_source.toLowerCase() + '-logo.png'" width="140" [alt]="transactionDetails.payment_source">
      </div>
    </div>
  </payarc-section-card>
</ng-container>
